export default "__VITE_ASSET__3_nZINgx__"